const notItems = [
  {
    icon: 'ri-briefcase-line',
    title: 'Kariyer sitesi değil',
    desc: 'Açık iş ilanları ve genel başvuru mantığı ile çalışmaz. Eşleşme algoritması ve kontrollü iletişim üzerine kuruludur.',
  },
  {
    icon: 'ri-whatsapp-line',
    title: 'WhatsApp alternatifi değil',
    desc: 'Platform içinde güvenli yazılı chat sunar. Telefon numarası veya dışarıya yönlendirme yapılmaz.',
  },
  {
    icon: 'ri-instagram-line',
    title: 'Sosyal medya değil',
    desc: 'Profiller herkese açık değildir. Görünürlük tamamen kontrollüdür. Beğeni, takip veya etkileşim odaklı değildir.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Terapist ajansı değil',
    desc: 'Terapistleri işe yerleştirmez veya komisyon almaz. Platform aracılığıyla eşleşme sağlar, arada durmaz.',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: 'Açık profil sitesi değil',
    desc: 'Telefon, adres ve iletişim bilgileri hiçbir zaman açık profilde görünmez. Tam anonimlik, kontrollü açılım ve KVKK uyumluluk temel ilkedir.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Açık ilan sitesi değil',
    desc: 'Spa işletmeleri açık ilan yayınlamaz. Terapistler de herkese görünür profil oluşturmaz. Eşleşme kontrollüdür.',
  },
];

export default function NotSection() {
  return (
    <section className="w-full bg-white py-14 md:py-20 lg:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-dark-teal-50 text-dark-teal-500 text-xs font-semibold rounded-full mb-4">
            Platform Farkı
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-deep-navy-500 leading-tight mb-4">
            Burası sıradan bir ilan veya mesajlaşma platformu <span className="text-dark-teal-500">değil</span>
          </h2>
          <p className="text-sm md:text-base text-gray-500 max-w-xl mx-auto">
            SpaProBridge, klasik iş ilanlarından, sosyal medyadan ve ajans mantığından tamamen farklı, kendi ekosistemine sahip bir platformdur.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
          {notItems.map((item) => (
            <div
              key={item.title}
              className="group p-5 md:p-6 bg-off-white rounded-2xl border border-gray-100 hover:border-dark-teal-200 hover:shadow-soft transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-xl bg-dark-teal-50 flex items-center justify-center mb-4 group-hover:bg-dark-teal-500 transition-colors duration-300">
                <i className={`${item.icon} text-dark-teal-500 text-lg group-hover:text-white transition-colors duration-300`} />
              </div>
              <h3 className="text-base font-semibold text-deep-navy-500 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}